import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import ClusterForm from '../components/forms/ClusterForm';
import '../styles/EmployeeMaster.css';
import ClusterTable from '../components/ClusterTable';

const ClusterEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [clusterData, setClusterData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/cluster/edit');

  const handleCloseModal = () => {
    navigate('/cluster'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getClusterById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setClusterData(data.data);
          } else {
            setClusterData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Cluster by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Cluster Master</h2>
      </div>

      {/* Table of SBUs */}
      <ClusterTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Cluster</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : clusterData ? (
            <ClusterForm clusterId={id} initialData={clusterData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this Cluster.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ClusterEditModel;
